export default "__VITE_ASSET__4ab36723__"